import { CreditAgreement } from '@finley-technologies/finley-types';

import { BaseFormFields } from '../types';

type CreditAgreementFullArtifact = CreditAgreement.DomainEntity.CreditAgreementFullArtifact;

export const getFormValues = (
  creditAgreement: CreditAgreementFullArtifact,
): BaseFormFields => {
  const parties = creditAgreement.facilityMechanics.parties;
  const result: BaseFormFields = {
    borrowers: [],
    capitalProviders: [],
    verificationAgents: [],
    servicers: [],
  };

  result.borrowers = parties.borrowers.map((borrower) => ({
    id: borrower.entity.id,
    slug: borrower.entity.slug,
    name: borrower.entity.name,
    description: borrower.borrowerEntityName.description || '',
    bankAccounts: borrower.bankAccounts.map((ba) => ({
      id: ba.entity.id,
      name: ba.entity.name,
      type: ba.type.value,
    })),
  }));

  result.capitalProviders = parties.capitalProviders.map((capitalProvider) => ({
    id: capitalProvider.entity.id,
    slug: capitalProvider.entity.slug,
    name: capitalProvider.entity.name,
    bankAccounts: capitalProvider.bankAccounts.map((ba) => ({
      id: ba.entity.id,
      name: ba.entity.name,
      type: ba.type.value,
    })),
  }));

  result.verificationAgents = parties.verificationAgents.map(
    (verificationAgent) => ({
      id: verificationAgent.entity.id,
      slug: verificationAgent.entity.slug,
      name: verificationAgent.entity.name,
    }),
  );

  result.servicers = parties.servicers.map((servicer) => ({
    id: servicer.entity.id,
    slug: servicer.entity.slug,
    name: servicer.entity.name,
  }));

  return result;
};
